



















































































































































import { Component, Mixins, Prop, Ref, Watch } from "vue-property-decorator";
import WindowEvent from "@/decorators/WindowEvent";
import { BroadcastersCatalog } from "@/models/SpecialInitiatives/Broadcaster";
import TrendMixin, {
  SpecialInitiativesColumn,
  SpecialInitiativesIColumn,
  SubjectColumn,
} from "@/mixins/http/SpecialInitiatives/TrendMixin";

@Component
export default class SpecialInitiativesTrendTable extends Mixins(TrendMixin) {
  @Prop({ required: true }) readonly periods!: SpecialInitiativesIColumn[];
  @Prop({ required: true }) readonly broadcasters!: BroadcastersCatalog;
  @Prop({ required: true }) readonly subject!: SubjectColumn;
  @Prop({ default: false }) readonly loading!: boolean;
  @Prop({ required: true }) readonly grouped!: boolean;
  @Prop({ required: true }) readonly unitOfMeasurement!: string;
  @Prop({ required: true }) readonly exclusivity!: string;

  @Ref() inner!: HTMLDivElement;
  @Ref() table!: HTMLTableElement;

  mediaTypes: string[] = ["TV", "RADIO"];

  position = {
    overflow: false,
    scrolledToRight: false,
    scrolledToLeft: true,
  };

  mounted() {
    this.checkPosition();
    this.buildSpecialInitiativesColumnsAndRows(
      this.loading,
      this.subject,
      this.periods,
      this.exclusivity,
      this.unitOfMeasurement,
      this.broadcasters
    );
  }

  setSort(column: SpecialInitiativesColumn) {
    if (this.sortColumn !== column.value) {
      this.sortColumn = column.value;
      this.sortDirection = "ASC";
    } else {
      switch (this.sortDirection) {
        case "ASC":
          this.sortDirection = "DESC";
          break;
        case "DESC":
          this.sortDirection = null;
          this.sortColumn = "";
          break;
        default:
          this.sortColumn = "ASC";
          break;
      }
    }
    if (this.sortDirection !== null) {
      this.rows.sort(this.sort.bind(this));
    } else {
      this.buildSpecialInitiativesColumnsAndRows(
        this.loading,
        this.subject,
        this.periods,
        this.exclusivity,
        this.unitOfMeasurement,
        this.broadcasters
      );
    }
  }

  get clientCount() {
    return this.unitOfMeasurement === "clients_number";
  }

  protected getColumnClass(column: SpecialInitiativesColumn) {
    if (this.sortDirection === null) return {};
    const columnClass = {
      "breakdown-table__column--sorted": column.value === this.sortColumn,
      "breakdown-table__column--sorted--asc":
        column.value === this.sortColumn && this.sortDirection === "ASC",
      "breakdown-table__column--sorted--desc":
        column.value === this.sortColumn && this.sortDirection === "DESC",
    };
    return columnClass;
  }

  isSorted(column: SpecialInitiativesColumn) {
    return this.sortColumn === column.value && this.sortDirection !== null;
  }

  @Watch("broadcasters")
  onValueChanged() {
    this.checkPosition();
    if (this.columns.length > 1 && this.sortDirection === null) {
      this.sortColumn = this.columns[1].value;
      this.sortDirection = "DESC";
    } else {
      this.buildSpecialInitiativesColumnsAndRows(
        this.loading,
        this.subject,
        this.periods,
        this.exclusivity,
        this.unitOfMeasurement,
        this.broadcasters
      );
    }
  }

  @Watch("subject")
  onSubjectChange() {
    this.buildSpecialInitiativesColumnsAndRows(
      this.loading,
      this.subject,
      this.periods,
      this.exclusivity,
      this.unitOfMeasurement,
      this.broadcasters
    );
  }

  @Watch("periods", { deep: true })
  onPeriodsChange() {
    this.buildSpecialInitiativesColumnsAndRows(
      this.loading,
      this.subject,
      this.periods,
      this.exclusivity,
      this.unitOfMeasurement,
      this.broadcasters
    );
  }

  @WindowEvent("resize")
  onResize() {
    if (!this.inner) {
      return;
    }
    this.checkPosition();
  }

  protected scrollToLeft() {
    this.inner.scrollLeft = 0;
    this.checkPosition();
  }

  protected scrollToRight() {
    this.inner.scrollLeft = this.getTableWidth() - this.getElementWidth();
    this.checkPosition();
  }

  protected checkPosition() {
    this.position.overflow = this.getElementWidth() < this.getTableWidth();
    this.position.scrolledToRight =
      this.inner.scrollLeft == this.getTableWidth() - this.getElementWidth();
    this.position.scrolledToLeft = this.inner.scrollLeft == 0;
  }

  protected getElementWidth(): number {
    return this.inner?.clientWidth || 0;
  }

  protected getTableWidth(): number {
    return this.table?.clientWidth || 0;
  }
}
